/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-nested-ternary */
import './video-player.css';

import { useScreenSize } from '@hooks';
import { Flex } from '@styles';
import { number, string } from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import screenfull from 'screenfull';
import { useOfflineVideoLoader } from 'src/hooks/useOfflineVideoLoader';
import { useOnlineStatusDetector } from 'src/hooks/useOnlineStatusDetector';
import { ControlBar, Player } from 'video-react';

import { StyledFlex } from './VideoPlayer.layoutProps';

const DEFAULT_AUTO_HIDE_TIME_IN_MS = 3000;

const VideoPlayer = ({ dynamicHeight, dynamicWidth, videosrc }) => {
  const { isMobile, isTabletSM } = useScreenSize();

  const videoPlayerRef = useRef(null);
  const { isOnline } = useOnlineStatusDetector();
  const [updatedVideoUrl, setUpdatedVideoUrl] = useState('');
  const playerContainerRef = useRef(null);
  const { getOfflineVideo } = useOfflineVideoLoader();

  useEffect(() => {
    const init = async () => {
      if (!isOnline) {
        const newUrl = await getOfflineVideo(videosrc);
        if (newUrl) {
          setUpdatedVideoUrl(newUrl);
          if (videoPlayerRef.current) {
            videoPlayerRef.current.src = newUrl;
          }
        }
      } else {
        setUpdatedVideoUrl(videosrc);
      }
    };
    setTimeout(() => {
      init();
    }, 100);
  }, [isOnline, videosrc]);

  const defaultHeight = isMobile ? '200px' : isTabletSM ? '300px' : '500px';

  return (
    <Flex ref={playerContainerRef} position="relative">
      <StyledFlex
        height={
          screenfull.isFullscreen
            ? dynamicHeight > dynamicWidth
              ? dynamicHeight
              : '100%'
            : defaultHeight
        }
        justifyContent="center"
        m="auto"
        width={
          screenfull.isFullscreen && dynamicWidth > dynamicHeight
            ? dynamicWidth
            : '100%'
        }
      >
        <Player
          ref={videoPlayerRef}
          fluid={false}
          height="100%"
          src={updatedVideoUrl}
          width={dynamicWidth}
        >
          <ControlBar autoHideTime={DEFAULT_AUTO_HIDE_TIME_IN_MS} />
        </Player>
      </StyledFlex>
    </Flex>
  );
};

VideoPlayer.propTypes = {
  dynamicHeight: number.isRequired,
  dynamicWidth: number.isRequired,
  videosrc: string.isRequired,
};

export default VideoPlayer;
